/// <amd-module name="Wit/UI/IdentityView" />
export * from "./Components/IdentityView/IdentityView";
export { IIdentityViewProps } from "./Components/IdentityView/IdentityView.Props";
export * from "./Enums";
